import primaryButtonAccentDefault from '../../../../../common/algorithms/primary-button-accent-default';

const primary = (params) => primaryButtonAccentDefault(params);

export default primary;
